module.exports = __webpack_public_path__ + "img/banner3.0b40b82f.jpg";